import createTheme from './createTheme'

export default createTheme({
  colors: {
    main: '#54127D',
    main90: '#662B8B',
    main80: '#78449A',
    main70: '#8B5EA8',
    main60: '#9D77B7',
    main50: '#AF90C5',
    main40: '#C1A9D4',
    main30: '#D4C3E2',
    main20: '#E6DCF1',
    main10: '#F8F5FF',

    darkMain: '#2a093f',
    darkMain90: '#3f2252',
    darkMain80: '#553a65',
    darkMain70: '#6a5379',
    darkMain60: '#7f6b8c',
    darkMain50: '#95849f',
    darkMain40: '#aa9db2',
    darkMain30: '#bfb5c5',
    darkMain20: '#d4ced9',
    darkMain10: '#eae6ec',

    accent: '#a1f3d0',
    accent90: '#aaf4d5',
    accent80: '#b4f5d9',
    accent70: '#bdf7de',
    accent60: '#c7f8e3',
    accent50: '#d0f9e8',
    accent40: '#d9faec',
    accent30: '#e3fbf1',
    accent20: '#ecfdf6',
    accent10: '#f6fefa',
    accent_dark: '#71aa92',

    focusColor: '#005eca',
  },
})
